import React from 'react';

import { MessagesProvider, Message } from '../Internationalization';

import messages from './messages';

const GDPR = () => (
  <MessagesProvider messages={messages}>
    <p className="mb-small text-small">
      <a
        href="/gdpr.pdf"
        target="_blank"
        className="link link-underlined text-color-grey"
      >
        <Message id="label" />
      </a>
    </p>
  </MessagesProvider>
);

export default GDPR;



// WEBPACK FOOTER //
// ./src/modules/GDPR/index.js